<template>
  <div
    v-if="uniqueSite"
    id="site-informations"
    class="p-4 my-4"
  >
    <h3 class="mb-5">
      {{ $t('sitesection.site.title') }}
    </h3>
    <h4><strong>{{ uniqueSite.name }}</strong></h4>
    <h4><strong>{{ uniqueSite.address.name }}</strong></h4>
    <h4>
      <strong>{{ uniqueSite.address.postcode }} {{ uniqueSite.address.city }}</strong>
    </h4>
    <div class="flex">
      <i class="pi pi-phone align-self-center" />
      <h4 class="ml-3">
        {{ formatPhoneNumberAsInternational(uniqueSite.phoneNumber, uniqueSite.phoneNumberCountryCode) }}
      </h4>
    </div>
    <p class="text-justify">
      {{ $i18n.locale === 'fr' ? uniqueSite.frenchDescription : uniqueSite.englishDescription }}
    </p>
  </div>
</template>
<script>
import {formatPhoneNumberAsInternational} from "@/shared/utils/phoneNumberUtils";

export default {
  name: 'SiteSelectionComponent',
  props: {
    uniqueSite: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  methods: {formatPhoneNumberAsInternational}
}
</script>
<style lang="scss" scoped>
#site-informations {
  background-color: $light-grey;
}
</style>
